const WELLTRAVEL = 'Welltravel';

export default WELLTRAVEL;
